// Model bytes travel in lazy application chunks, so a separate binary request
// cannot redirect to the sign-in page or resolve to an old public asset.
export function decodeCharacterData(url: string): ArrayBuffer {
  const separator = url.indexOf(',');
  if (!url.startsWith('data:') || !url.slice(0, separator).endsWith(';base64')) {
    throw new Error('Character asset is not embedded binary data.');
  }
  const decoded = atob(url.slice(separator + 1));
  const bytes = new Uint8Array(decoded.length);
  for (let i = 0; i < decoded.length; i++) bytes[i] = decoded.charCodeAt(i);
  const header = new DataView(bytes.buffer);
  if (
    bytes.length < 12 ||
    header.getUint32(0, true) !== 0x46546c67 ||
    header.getUint32(4, true) !== 2 ||
    header.getUint32(8, true) !== bytes.length
  ) {
    throw new Error('Character asset is not a complete glTF 2 binary.');
  }
  return bytes.buffer;
}
